import { isMobileApp } from '@shared/utils/descopeQueryParams';
import { isEmbeddedBrowser } from '@shared/utils/detectDevice';
import {
  getWebAuthnCapabilityOutcome,
  QA_DESCOPE_PROJECT_ID,
  type WebAuthnCapabilityOutcome,
} from './passkeys';

const PRODUCTION_DESCOPE_PROJECT_ID = 'P32ACVpudk8MNftmpf1LR1pW5k8s';

export type PasskeyRegistrationClientCapabilityOutcome =
  | WebAuthnCapabilityOutcome
  | 'embedded_browser'
  | 'native_flowview'
  | 'unsupported_environment';

const isProductionProject = (): boolean =>
  (import.meta.env.VITE_DESCOPE_PROJECT_ID ?? PRODUCTION_DESCOPE_PROJECT_ID) ===
  PRODUCTION_DESCOPE_PROJECT_ID;

const isProductionStage = (): boolean =>
  (import.meta.env.VITE_STATSIG_STAGE ?? 'production') === 'production';

const isQaProject = (): boolean =>
  import.meta.env.VITE_DESCOPE_PROJECT_ID === QA_DESCOPE_PROJECT_ID;

export const getPasskeyRegistrationClientCapabilityOutcome =
  (): PasskeyRegistrationClientCapabilityOutcome => {
    if (isMobileApp()) {
      return 'native_flowview';
    }

    const webAuthnOutcome = getWebAuthnCapabilityOutcome();
    if (webAuthnOutcome !== 'frontend_capable') {
      return webAuthnOutcome;
    }

    if (isEmbeddedBrowser()) {
      return 'embedded_browser';
    }

    if (!isQaProject() && (!isProductionProject() || !isProductionStage())) {
      return 'unsupported_environment';
    }

    return 'frontend_capable';
  };

export const isPasskeyRegistrationClientCapable = (): boolean =>
  getPasskeyRegistrationClientCapabilityOutcome() === 'frontend_capable';
